exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#car-insurable-extras.v-input--selection-controls,#car-insurable-extras .v-input .v-input--selection-controls .v-input--checkbox{margin-top:0!important;padding-top:0!important}#car-insurable-extras div.flex.v-label.v-label--active.theme--light.md12.xs12.offset-md1.offset-xs1,#car-insurable-extras div.v-messages.theme--light{min-height:0;height:0}#car-insurable-extras div.v-input.v-input--selection-controls.v-input--checkbox.theme--light{margin-top:0}#car-insurable-extras .v-input--selection-controls .v-input__slot,.v-input__slot{margin-bottom:12px!important}", ""]);

// exports
